import AxiosPlugin from "@evercam/shared/plugins/axiosPlugin"
import { defineNuxtPlugin } from "#app"

export default defineNuxtPlugin(AxiosPlugin)
